import React, { useCallback, useMemo, useState } from "react";
import { ChatWidgetContext } from "./ChatWidgetContext";

export const ChatWidgetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [pendingMessage, setPendingMessage] = useState<string | null>(null);

  const expand = useCallback(() => setIsExpanded(true), []);
  const collapse = useCallback(() => setIsExpanded(false), []);
  const toggle = useCallback(() => setIsExpanded((v) => !v), []);
  const submitMessage = useCallback((text: string) => {
    setPendingMessage(text);
    setIsExpanded(true);
  }, []);
  const clearPendingMessage = useCallback(() => setPendingMessage(null), []);

  const value = useMemo(
    () => ({ isExpanded, pendingMessage, expand, collapse, toggle, submitMessage, clearPendingMessage }),
    [isExpanded, pendingMessage, expand, collapse, toggle, submitMessage, clearPendingMessage]
  );

  return <ChatWidgetContext.Provider value={value}>{children}</ChatWidgetContext.Provider>;
};
